import QuickJobsApi, { IPaginationParams } from ".";

class Feedback {
  protected client: QuickJobsApi;

  constructor(client: QuickJobsApi) {
    this.client = client;
  }

  public getAllFeedback(params?: IPaginationParams) {
    return this.client.httpClient.get("/feedback", {
      params: params
    });
  }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/libs/quickjobs-api/feedback.ts